<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>

    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>

    <el-divider direction="vertical"></el-divider>
    <el-tag>输入起止日期：</el-tag>

    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList" :disabled="isDisable" round>查询</el-button>
    <el-divider></el-divider>

    <el-table
      v-loading="loading"
      element-loading-text="拼命查询中..."
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        fixed
        prop="campaignName"
        label="计划名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementId"
        width="120"
        label="广告ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ACCOUNT'].includes(this.values)"
        :formatter="rule2"
        prop="disGeneralBalance"
        width="180"
        label="虚拟金">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="uuid"
        width="120"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"
        width="120"
        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"
        width="120"
        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="balance"
        width="100"
        label="现金余额">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        label="撞线警告">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.flag">警告警告 </el-tag>
          <el-tag type="success" v-else-if="!scope.row.flag">平安 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"
        :formatter="ChangeToPercentage"
        label="点击率">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        width="80"
        prop="spent"
        label="花费">
      </el-table-column>
      <el-table-column
        sortable
        prop="formsubmitCount"
        label="表单提交量">
      </el-table-column>
      <el-table-column
        sortable
        prop="but"
        label="表单成本"
      >
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
      <el-table-column
        prop="customPayCount"
        label="自定义付费数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdyff"
        label="自定义付费数成本">
      </el-table-column>
      <el-table-column
        prop="reactivation"
        label="自定义拉活数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdylh"
        label="自定义拉活数成本">
      </el-table-column>
      <el-table-column
        prop="customRetainCount"
        label="自定义次留">
      </el-table-column>
      <el-table-column
        prop="zdycl"
        label="自定义次留成本">
      </el-table-column>
      <el-table-column
        sortable
        prop="CVR"
        :formatter="ChangeToPercentage"
        label="转化率">
      </el-table-column>
      sortable
      <el-table-column
        prop="CLR"
        :formatter="ChangeToPercentage"
        label="次留率">
      </el-table-column>
      <el-table-column
        prop="reportDate"
        label="日期">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"

      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" v-if="flag" type="text" size="small">查看</el-button>
          <el-button @click="edit(scope.row)" v-if="dingshi" type="text" size="small">定时</el-button>
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="时段成本"
      :visible.sync="table"
      direction="rtl"
      size="50%">
      <el-table :data="HourList"
                v-loading="loading"
      >
        <el-table-column property="reportTime" label="日期" width="150"></el-table-column>
        <el-table-column property="campaignName" label="计划名称" width="200"></el-table-column>
        <el-table-column property="nameid" label="名称"></el-table-column>
        <el-table-column property="spent" label="花费"></el-table-column>
        <el-table-column property="formsubmitCount" label="表单提交量" width="200"></el-table-column>
        <el-table-column property="chengben" label="成本" width="200"></el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="修改开启时间" :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog1">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {


  data() {
    return {

      loading:false,
      isDisable:false,
      userUalue:'',
      options1: [{

        value: 'tangtang',
        label: '葛磊  ',
        children: [
          {
            value: 'zabx',
            label: '众安保险'
          },{
          value: 'thys',
          label: '拓航养生'
        },{
          value: 'fjwc',
          label: '可可金线莲'
        },{
          value: 'tabj',
          label: '推啊白酒'
        },{
          value: 'tianc',
          label: '天赐'
        },{
          value: 'gonjj',
          label: '工匠酒'
        },{
          value: 'wzjiu',
          label: '王子酒'
        },{
          value: 'qhjiu',
          label: '青花酒'
        },{
          value: 'ftjiu',
          label: '飞天酒'
        },{
          value: 'yangnai',
          label: '羊奶'
        },{
          value: 'fnbj',
          label: '丰诺白酒'
        },
          {
            value: 'tgxys',
            label: '踏歌行养生'
          },
          {
            value: 'hy',
            label: '少梅金线莲'
          },{
            value: 'aicp',
            label: '爱测评'
          },{
            value: 'ltsq',
            label: '蓝天三七'
          },{
            value: 'lttm',
            label: '蓝天天麻'
          },{
            value: 'lltb',
            label: '乐龙淘宝'
          },{
            value: 'llks',
            label: '乐龙快手'
          },{
            value: 'zgbzf',
            label: '赵哥孢子粉'
          },
          {
            value: 'azmc',
            label: '阿哲莓茶'
          },
          {
            value: 'azxys',
            label: '阿哲西洋参'
          },
          {
            value: 'yjj',
            label: '杨静静西洋参'
          }
          ,  {
            value: 'xhsh',
            label: '小花石斛'
          }, {
            value: 'jzhd',
            label: '极准互动'
          },{
            value: 'zcrmc',
            label: '直采人莓茶'
          },{
            value: 'qqsh',
            label: '青青石斛'
          },{
            value: 'lhsq',
            label: '龙华三七'
          },{
            value: 'qwyy',
            label: '奇蛙瑶浴'
          }   ,{
            value: 'zgyy',
            label: '赵哥瑶浴'
          }
          ,{
            value: 'sqyj',
            label: '三七原浆'
          },{
          value:'jmhd',
            label: '巨摩互动'
          },{
          value: 'lhhd',
            label: '诺禾互动',
          }
          ,{
            value: 'qdsq',
            label: '七丹三七',
          }
          ,{
            value: 'fzy',
            label: '枫籽油',
          }


        ]
      }],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],







      lhsq:[
        'a7911b191bfa0d0fa1df',
        '79d0210099bcdfe7a0dd',
        '438877506fa167bd91cd',
        'f24d73527286503ac347',
        'eb6a31d4039ec85edf77',
        'a63fd3dc90c847b86aef',
        'dd9a5e8a32b2c85af1b0',
        'baacfea28d26e90a2bfa',
        '25d5f5fdcb501768754d',
        '09974b18191afac58c17',
        '0708fd875e5a864c04b1',
        '0449ab0684a302e50edd',
        '4534b3965d819327ed0d',
        '09e9d17d7cbc04f0a478',
        '61a687cf6c1a0e6a98b9',
        '7695105acf4aa15e714d',
        'f5c3919309fdf99f4375',
        'bac44f3b189f71747cc4',
        '618f3729f8b244ea2b9e'




      ],
      lhsqtoken:['985b82c3470b73663a3c01143d3839c4c25ec7520c4b439075288e2ceb7068a5'],

      fzy:[
        '270a848cedf06bb5b8de',
        '11a8e5a7ccfadec89a83',
        'ce01efcbc6cdd70526e2',
        'a2182b8de1dcac1ef168'
      ],
      fzytoken:['985b82c3470b73663a3c01143d3839c4c25ec7520c4b439075288e2ceb7068a5'],


      zabx:[
        '1e934309350b5cc877d2',
        'c49525307a74eddaa083',
        'cc5adeede3c7b64806a9',
        'fa1f7eaf89acc26f7aae',
        '390421515cb675f07ae4',
        '6ff62d192ed13f5f458c',
        '4e1e2788a84409d6306a',
        '6de106ec5673aafd469e',
        '04acd3f506977a3033e7',
        '05d62b7f4cbe97459b8c',
      ],
      zabxtoken:['51a82018246910cec75ffd671c4152d8f5714fcdecae031a2233935713f1e49f'],

      thys:[
        '3d88f8804e2a7f90f8f1',
        '7e9c1f93b17cb734e1c6',
        '900085b8940c472687cd',
        'cd3bee685d66814b5e0d',
        '2cfdd4419c0dde330ab3'

      ],
      thystoken:['985b82c3470b73663a3c01143d3839c4c25ec7520c4b439075288e2ceb7068a5'],

      tabj:[
        '96c4b11b98c2315a59d9',
        '345b59ea2c77402eb703',
        '2a38a87461b0ab83520b',
        '974305494b5cdeef4cd1',
        '4b3de9dece5618b7bfdc',
        '593738217b87c89ff9eb',
        'e80b86019eade75c7e96',
        '237a8c9c33f8223a8dfa',
        '326d88e39a22ba5adbe4',
        '85328250be7102732054',
        'b5f588baf881d60237bb',
        '2280059b5cd633e8223c',

        '9b93e7d15b813204f223',
        '02f7ccf6dc63d80e1c1a',
        'ff5f358380bf8ac92bed',

        '622506144ecd46e62228',
        'fc8eb01f045d6e6e128d',
        '701559b7e84adb77f29a',
        'bab3a66255c5d52b1abb',
      ],
      tabjtoken:['d134a3b08c626b4560afc4d8af62dc381cff065a97d3b51a19fdf2ebc5e692ab'],
      tianc:[
        'e9cb64b1e9b0ee87fe91',
        '2457639ae76b141b2118'
      ],
      tianctoken:['da7741bca463661b069b8d6eb90370f67d2631141787189bc1547208d2024977'],
      gonjj:[
        'b5f588baf881d60237bb',
        '02f7ccf6dc63d80e1c1a',
        '701559b7e84adb77f29a',
        'ff5f358380bf8ac92bed',
        '6bd0e5f5073b8cced580',
        '79be286af7ca4880c57a',
        'f99ea3b0304792b3df53',
        '1b20622f5b0bbcf54d5e',
        '0f64a858321606b3dd6b'
      ],
      gonjjtoken:['da7741bca463661b069b8d6eb90370f67d2631141787189bc1547208d2024977'],
      wzjiu:[
        'c7c800a306870fd981ee',
        '55b016b36b4af76034ee',
        '0330fe1ca3b7a80172bb',
        '60e23516d8ef09c358f4',
        '36d6207999b5b5d41f32'
      ],
      wzjiutoken:['ddf390f6bec33b9d5d6b7c6f47872c37fb76068cafb38ac6b2658764f6555dc3'],

      qhjiu:[
        '519df6909cef5b31c312',
        'bb3d5ac299072e1555e4'
      ],
      qhjiutoken:['ddf390f6bec33b9d5d6b7c6f47872c37fb76068cafb38ac6b2658764f6555dc3'],

      ftjiu:[
        '08165f5289825f400240',
        '4a9d87302fbb5a3cd4c7'
      ],
      ftjiutoken:['da7741bca463661b069b8d6eb90370f67d2631141787189bc1547208d2024977'],

      yangnai:[
        'd461cfac6ce4744ac0aa',
        '9742632acafc67d116ed',
        '02830fb77e0fafb05b9b'
      ],
      yangnaitoken:['da7741bca463661b069b8d6eb90370f67d2631141787189bc1547208d2024977'],


      fnbj:[
        '547e4bf991166f4d0eab',
        '56ef4645ca265a80deb1',
        '0c61e32a3eb4ae897937',
        '6a6b4f35258f622a9100',
        '0390ad46f97744c00af9',
        '5cd956dd83aeafd69ae2',
        '8528a2cf9ba64cbf5b25',
        '6a3d184588244a6bc498'
      ],
      fnbjtoken:['6851a097365adea630a73b8f82280cd6cdd83fb5121a9907577c33aba64759e3'],
      tgxys:[
        '063556d689b5ab81a60a',
        'df9618acd32e03ad20b1',
        '4364c32a62bf44d18cd3',
        '511f0fa738db530eef72',
        '2cf9787e7bcdff263f45',
        '7b6cf50b77eb7cdb4998',
        'e7e59e303dd3b9228c77',
        '70b9abe1285d214c70a7',
        '516a79e04f500cef80dc',
        '22dc7111b1d95845bd4b',
        'bb3fd884be95157bc2f7',
        '914a73d7c3be0e0cd58e',
        '0e4fcc02ef4e29099f73',
        'b69e93079decff4b8d2b',
        'a9bb5ab98e05dba156e1'
      ],
      tgxystoken:['1b9299a86e29dce58e285c6c4646e35e5899cd829cd0395bc5a4930b3cd6cce4'],

      lltb:[
        'bb9767f90d8c0b6fb1f0',
        '79dd20c5650638ba4807',
        'f48ed958077712e0a7f1',
        '8b85c62b1117a2d9529c',
        '16c70ce13c5e6d2e072e'
      ],
      lltbtoken:['8c4a3fd3a4e8772cebdec5ff682dfa6a0d5ee863296990a79a06bd191648a3a6'],

      ltsq:[
        'f851943dce12c18b32b2',
        'a371282f5d81830d7f44',
        'c1bca24c0fb0ffd01efb',
        '87db2471272400e15538',
        'ffc1b41903742b8db500',
        '35e69f4a1ed043d3ea5c',
        '468c3612de4a0beb0b2c',
        'f85ca869d65d7438cd74',
        '80a1cc26bb725caff8fa',
        '277cb38c52643c8f8db3',
        '54d24bf91067d96853cc',
        'a55f0abe4567482bfcfd',
        'ba154f4cbd3c36579b13',
        '9e77d2e12ec092427d09',
        '7ed770da2e58edcaf341',

        '28163e60194a1c4052d8',
        'cf7d4d018714eab4f282',
        'd07307fcab39f18a94d1',

        '9e514f78bbeae3401781',
        'e011aeb7a1052f34d542',
      ],
      ltsqtoken:['dd7b164e4b899ab3d1b94dde29ef31665c4fe2fe326b4b0c930416ad0d06a98c'],


      lttm:[
        'a084690a8431efe4d6e4',
        '7df397ded00b27420767',
        '005442f55f986e48d8d3',
        '6adcdcbe705e0d3e311a',
        '7c27dc79cfe9e76b913f',
      ],
      lttmtoken:['dd7b164e4b899ab3d1b94dde29ef31665c4fe2fe326b4b0c930416ad0d06a98c'],

      aicp:[
        'dd5995af4a51e36c8b57',
        'e5652ca2a707f0534538',
        '344bec15f6e976b0c8ce',
        '2c688f49bd705765cc04',
        '3586f60168e1b7278ed1',
        '3fee9b2f658dc6ed9562',
        '2e4cefb80c506c953771',
        '1fc49a0b20174af5c76f',
        '7808c0ee90b9d5f8c89a',
        '68caf442ba3eff43f459',
        '41873ba798259e385697',
        '9db778dfc363ce99362d',
        '13706d55a3d1ed92040e',
        'a48f91b4437f3776dda3',
        'a6931cf7b04fe4947d8c',
      ],
      aicptoken:['303485872e860966a38e658526494792c0d8c1a4f7d9e966243614a64c3eea88'],


      llks:[
        '0d970dfd27db7f2260aa',
        '852ed88e73e0f2799dcf',
        '11e3eb1c725f596e1f1f',
        'ba751dda3ae70760f177',
        'b02a5f59973a6147e19e',
        '0557a4da179c76cf5c04',
        '8b9f0afc4462c6adb830',
        '6af2d2a94cf9d40cbd55',
        'fba9bb330abbe458d631',
        'a4de1a26082fb2cef523',
        'ae4f23b78cdc8d9b130d',
        'f0aedaa08a670ea460da',
        '578bb4e22fdf539ace99',
        '5de455d92abcfc540bc5',
        '4b0362972aec7d6994f3',
        'd3c4417f29fc49c6f15a',
        'aa0549d598c4288c0f34',
        'b5e8e8d17255ad2bacb9',
        '60c21eee4ca2a6cfd5ec',
        '877b434f5aa6d3337c14',
        'cf6d06bea265c13bf536',
        '1edfd97f1241e6e134d5',
        '0ff7642a87364b4a3678',
        '9a452e42dfbeaee274f8'
      ],
      llkstoken:['8c4a3fd3a4e8772cebdec5ff682dfa6a0d5ee863296990a79a06bd191648a3a6'],

      zgbzf:[
        '642328c673d77b3428e1',
        'b3000602aef1939cc766'
      ],
      zgbzftoken:['985b82c3470b73663a3c01143d3839c4c25ec7520c4b439075288e2ceb7068a5'],


      lhhd:[
        '78a456c5d1c8c6588f8a',
        '063b846deb0c00667599',
        '56eb30f4ea275955639d',
        '8fecde3259457179c39d',
        '11c2c6f3655458f87a7b',
        'd9cc9c6e3eef296dbae5',
        'a1603b9d4ae56740a9bc',
      ],
      lhhdtoken:['f665c3b96ef7d590317e5e0e64c0b5c1823e4ee629ed45c07c6cb5939f7bdf24'],

      qwyy:[
        'fcc966af90c71c695e90',
        '4a66daa3f9fadfc5b01c',
        'f461cfb2708a673a935b',
        'c8931aec1deddcea2367',
      'bb54144ae529cb9ff104','782ae2917406f41a931d',
      '110f61dddcf17dc42d2b',
      '39482a293cd8d15c6d37',
      '02ec48fb526f6dc220c4',
      ],
      qwyytoken:['fd91d2374a41522e41efdeadc0c53a43c3237801945bd781387c267990632b81'],
      qqsh:['692e7daa581911098f42','bdbad38c58e6c5eab117','44e7049e937067502733','00d5a1465fca53c389d1','e93fe2715f35f12c9aee',
        'b68d018a4bab77e29f99',
        '5b35915126e2ba1e234d',
        'f206ca6f07e6bf3a696d',
        'bea81108dafbf441c6b4',
        '11a0dc96d97565443924',
        '1f85de92a23cdb8cfa24',
        'ed8a1e5ae3c74d0dc99f',
        '50ff412bc4d482c9a424',
        '41ba1849c0ff4497a7a1',
        'e8b71ee56b771f802e06',

      ],
      qqshtoken:['953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5'],
      azmc:[
        '6d9842ee4c6a2adfcf55',
        '1b7757627195685cf10d',
        '92565c16a8d76eb31c6c',
        '2ab880d734756e7f72dc',
          '56bfcbbfc8037683b58b',
        'dd3df2125532ab9ceaf6',
        'f1fddfbbb83d1481fde0',
        'ef97f62769462479f774'],
      azmctoken:['985b82c3470b73663a3c01143d3839c4c25ec7520c4b439075288e2ceb7068a5'],

      azxys:[
        '80bec8e5836058a40329',
        '244a6b6851a2a73ef8c7',
        '2052c561ed4050a0422c',
        'e0948ef48670150b87d5',
        '07b75d7e3b4ae950321d',
        '95f9f0dce021b1a41955',
        '6af4e7ed3796527b2c56'
      ],
      azxystoken:['985b82c3470b73663a3c01143d3839c4c25ec7520c4b439075288e2ceb7068a5'],
      zcrmc:['6e61c0f62865973b4333','17d0614846bd23bcd7b6','f52178fff2e2aec206c8','5fe85847abd10873123d','5c081d2176f3b560e532',
        'ba505e1a6a4d689af18c',
        'a56d49ac878eb13cd456',
        'd6bfd90e45386c46fa88',
        'f2879afbfaa9a9c1205d',
        'c6aad5580f89445b32ac',

      ],

      zcrmctoken:['fdab982e574007f76c1bb9f4bd057fda2622d2b4d45de5f8c3835615710c283b'],
      zgyy:[
        '203fb3ba12aa282304eb',
        'f53fb5712288895fea1c',
        'd8aca465a4e4a524b7a0',
        '8e88ccbe67dcd7b33427',
        'd45ce0d3c9fb9e7244f6',
        'c7af0de05840f7ac446c',
        '39a83f5d885a101711bc',
        '863ab555d0399241a987',
        '05b011ef2e470d204b3c',
        '4f8049a1ff49baf98c80',
        'c9f4feea5b7c8ba387f7',
        '15267c5e02cb3ff3523b',
        '7ea98aeef4ad505bec25'
      ],
      sqyj:[
        '130d5f1e29fe116ee958',
        '2890232b6e6a140903d0',
        'e0f126b582d82d1d0bfe',
        'faa878c0e1aa7a6966e6',
        '03ca2febd77bdf3db4ab',
        '6fc9a8a52377938bd51e',
        'e8510cd12e5d55886764',
        '76123710fa42c8d91f87',
        'efca6b1f497f79e2a51f',
        '0e7d45429039d21398e6',
        'e0783bf51c70c3e56265',
        '5ee474af2ddaa25b0f60',
        '56b0f0954671f720b864',
        '0e8b5be948aefd497b21',
      ],

      yjj:['3b0d1f842d3b87038942','7ffda0d926a8299e5504','b5ffced50c412d62de10','305666a9a53f9e64213e','7279548e5544031f3457','46e9507ce93d891612fa','e80ef274d58a8ab11506','490593eb58850b3dd118'
      ,'346ff8d7428942fbca14',
       'b61ac13b0988b23a12e4',
       '453c3dfcbacc4f43e073'],
      jzhd:['1e1508813e049f7c5ca5','cc415105f894651c3959','6ed38d7236b199224fc0'],
      jzhdtoken:['9ed71506c6cf657bef789df26eb6c6cd4ba4becb25798be9196ebeb9a398de86'],
      xhsh:[
        'bd1c61b48e2f13ef2a42',
        'ba61caa05b8a5498d4cb',
      ],
      xhshtoken:['860de1be50a355aaabc1c3773126af95cb487a27ce552024ba074c8970ed0b8a'],
      ttgx:['302f2aed267d613e6b72','04ec3fd52f0a03708146','42ac042d7aaca972fa23','ca0a221c99cf8d0abc28','1b8d5cf361f7f8fbfb26'],
      ttgxtoken:['d0cfb5b854c08aa30f2e4a871347f59aad0e22c35b9ebe567a8a9547c8c1239c'],
      bbkj:['22b811be804b838e1696',
        'c8f6658850ebca3cdf9b',
        '5f366cfa13a03d74cf5f',
        'a52528ff997445f58950',
        '604511525745489db137',
        '988003bb4feaeb1bef07',
        '021c615829deb9731522',
        '5bd75506f364e3ac5c63',
        '599ce3b956f0729621d2',
        'a9cacf81559c9680cf95',
        '0bebee59bdc1e10d292b',
        '06e1789983c9612ec7d7',
        '5ecd5c27104dac720ae9',
        '0d3af6dacb8738989cd6',
        '2b87518caffc02801902',
        '50ee73566fa5fc9230ca',
        '185bba21d3b3c63d6542',
        '96783e74dd7ddfe2d946',
        '43611efcb7af222dc60c',
        'ed89b48f72fda0f73914',
        '7041b6642152d43b4c9f',],

      bbkjtoken:['edce2a9fe9b14c4385921a2aa99c509cbbfc83cdaaf5f76c3c7e648730bbaaa4'],
      bxm:['195bbfc16bab5b65ff8b',
        'e5030ea6ac4001018dad',
        '9ef4ed842437c673b089',
        'e68392e47f2334c337b2',
        '8b2f26efb30a7be6e8df',
        'c5a30a7da8616f7b8937',
        '4168d3b7b2e398041cbb',
        '6942d768ed1d3d88e928',
        '934386cdeb89993056a9',
        '7e0fa2d56f7c512fb78e',
      ],
      jhcstoken:['d0a9fb1f975a65da1757fab3db4f5acf5ba2a8edf94bac6cd7f92dbfe9a9fffa'],
      jhcs:['e53603d33cd644d4bd4e',
        '3b8c506f9cdc1c4f33d3',
        '53e39311bb5465890f9e',
        '4d60736d4cb4236acf0a',
        '345e3701d4bf327f8556','082b115ff130516257aa','7b0f889b04ce3013d7fc','d38450efb00309b1e2b7'],
      //数据
      ljs:['03ac01639b584c994b02',
        'e50a7e1004cf02a2a333',
        '699c4d04827bc28379be',
        '1107f01e718602733104',
        'e88ebfa1fe57c3a0e581',
        '4aca573255c3974548da',
        '966b43381f4e8f01e1e3',
        '0bea0ac8872a727db96a',
        '0a2e61abf4b092af26cd'],
      ljstoken:['d94b163c7c640fb3efecc297bfe7cc83a43469baf19964a89dfec075d2e79c11'],
      zgyytoken:['985b82c3470b73663a3c01143d3839c4c25ec7520c4b439075288e2ceb7068a5'],
      bxmtoken:['b2ccbbe22a1e7f2cfe1be4a81aac4cb1beb155db5f5863c143d0600dd47dd63d'],
      xiaoqing:['1b39ec617071e23de1c865ea772c1eace6392f195781a9128405a0d19920ea3d','e02e2618fc793dc152d82ce2ded524f97d775e108b295a1ce338117ca096fd5f',
        'cb40eea503b274dadca8c71634393d407af24c9c0c2aa095c7c8665ec07f1d4e','b76f84d0eb68aea6faee58e82ad7cc652f7187eb23ef1b9d3d7f8eeb09cfba10','155c2a24cccce986528990fa6401d22ae727a8d49dc98dd64d2b752993a59923'
      ],
      xiaoqing1:['6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7','bebae681e51f6c6d61181a1068bd861766755848946f1839d649ca4933378a86','e18203affbefa3ae8a544f4932ba0c816acdee42026cebaccad62af898f1480b'],
      zjwc1:['a84d159a9cd6f2a605c4','ed8613d1bf8d958506bc','d072259f4d71223acd7d',
        '87120a5bd5bf5aa59401','79ae6653fec4d52adcd4','6ca615644f81185d6e96'],
      jsgx:['208538fad40c9796ec00','08de207541e54d033eb7','66046cfed9f87891115e','f0760f6cfe8d319e3bef','a1254894a9a764c6816b','8625b7a0955d398442a4','d1d4707e543526a059e2','480ea6b22f8ffa50e136','0e2399938ab77f5b91cc'],
      jstb:['f3d4eb9d4acfeccbd1bf','6888ae8ac48159ec2fa3','dce582c5ba18e4763eb6','9855ab445099a15b00e7','78e3e38db1293782c583'],
      ysgx:['9a3be560564b951550a6','c77c4948b07e8322c93f','e45ffb7db04197a72fe1','de4a95c9472a36aa9e38','586f137a4a132e09c285'],
      zuoen:['c2a16d4047d3d096b2700701fb5caba784e3c1031903fc8207b97b56909ab7a7'],
      marryu:['873a63615f6e42478a3b','1c96ea51e138b5a10655','01739c18a49cff216f35','d9dadce1a1edf45a862d','a99e101d860a977cb6dd','baa7f15045eed2cf32d5'],
      tangtang:['fbc5b9acfe4f38cc80a4f199fd038907e62ffb193d78f4a1b90fb6f96a454b0a','c47cacfcedfd9e6955d189dfcb770674c94f8963a31535fb7a8df49ae02e6463','a823e200bc8f6a8edbbb56335c65ef65aa9bfa6e67f902ef073a28c97608ee71','16e6fff7524a94b079988e02666c34df673eb83ca021d958bc71ae2e141d10eb','6fbc3e0801e3baff097d6e7b3b4e4fd90d0d8587efa063f33777b7a31aa6b0a8'],
      yx:['442b5166f881150e46b9','79f406ec252961769310','ba36dcea3137e116ae79',
        '9e18f3c554964048ac44','00f0c083cf777e77e185','0e1917559d9e93ce4b0b','31f09b92a6b5b2f11ac6','b98a585d4fe8316710a4','6357f7b3b1e16e28171f','784e3f170e50b29688cc',
        '22dc85bba6567bdad22a','00b81a9fe132dac07668','6eddd3ee5768e94e4301','ad1ef2553cb1a3844100','55085e672d1e8a80f992','731a4bc517e815cf0df2','d9ad29be8ddff6d149f6',
        'a3172990b528aa3adefa','e9675a96e1b0e95ebb2b',
        '6a154ac3b7af61ed6548',
        '97fbc72a34295b4c0ec8',
        'd3fdda946f5624cdb492',
        '0959f969013a57d31371',
        '340886508210f0f501dd',
        'efbfa39641cac31ffad5',
        '7d52a9294d446255ae1a',
        'fdb2a6f29d62c80c0284',
        '470771cd88a81932af63'
      ],
      jz:['9c84ff01b2002c313f78','9ec83abe20e3ad60eb53','b0ca65ba000335d4c0dd','7502e46e04191ab85503','7a64bbfbffb03624a5a2','ebfaa67832321c9da17f','90db4c79cfa27156cd3b'],
      jztoken:['c72108312e413d84f674126066559f622dced5fe853a28e8d24064b19c9b56c2'],
      fjwc:[
        '816678be373bb971877a',
        '4df4f1aa904d16472dc7',
        '69de5a4d2788788d6a7f',
        '8c703e54e8a8d0355958',
        'aaa1ac7f1b68d9b1b657',
        '9458787070fe5650484f',
        '7e1a0930f52dcff74aba',
        '64a9efc08f0f0f224adb',
        'a9603fc2688d4b5aff78',
        'f387afa316ae21933839',
        'f3a1accbd92aa1eb550d',

      ],
      hqyt:['c96e23acbd5fd6e7cb66','4ed4a08ef7c07d504252'],
      zer:['5b1af45ef6a8563c697a','01afe82d1fdc5f68fa19','cbb2ee601e6831ebf9e9','b4e129ce38fe4d111a13','1f1eaf8b4cb0813b9dc8','2b5e90d8af1a0f00377a'],
      hy:[
        '88f21252b663573c387c',
        'ca868a2292895b4ba752',
        'f682c329bdc78f7b1b47',
        '0600a0b815027aac89da',
        '172ecafba2ebc872ddd9',

      ],
      jmhd:[
        '7f756c9020053b15cf2b',
        'aec8bae0068649e956cf',
        '2ba93b5edabe8979b6a3',
        'c7290f2383f5a7e185e7',
        '5be484cfbce97c7d2d5d',
      ],
      jmhdtoken:[
        '0f99cb26bc4b6a0084292549b6395918c781bcc916943d6fb8daa3359bd037ee'
      ],
      qdsq:[
        '209295365755758a345d',
        'adde43f17786477cbdba',
        '88bf956c9362226c0f1f',
        'ed41d413a1f0b379badc',
        //2023.9.11
        '0239554e42614233f356',
        'a65ec995f745fe62c8b8',
        '52c890c3f6290c7d10d1'
      ],
      qdsqtoken:[
        '1b495987973a709cd7485d238971f5e01dee22376f57e6ddc91d152a6b10aaa0'
      ],
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      money:200,
      value3:'',
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      ctrJson:[{
        flag:false,
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],
      playCode:[],
      TempData:[],
      table:false,
      dialog: false,
      dialog1:false,
      HourList:[],
      Hourmap:new Map,
      sums:0,
      flag:true,
      form:[],
      group:{},
      kaiguan:0,
      activeName: 'first',
      grouplist:{},
      dingshi:true,
      xiane:true,
      sks:''



    }
  },

  methods:{


    //面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }

    },

    //限额方法提交
    updateEd(){
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }else {
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }


      this.dialog1=false

    },

    //投放时间方法提交
    updateTime(){
      let endtime='2038-01-19'
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }
      else {
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }

      this.dialog = false
    },

    //限额
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog1=true
    },

    //投放日期
    edit(row){
      this.grouplist={}
      this.grouplist={
        userId:row.userId,
        groudId:row.groupId
      }

      this.dialog=true
      return row
    },

    //显示表单
    handleClick(row){
      this.HourList=[],
        this.TempData=[],
        this.TempData.push(row)
      for (let key=1;key<=this.Hourmap.size;key++){
        // console.log(this.Hourmap.get(key))
        for (let keys=0;keys<this.Hourmap.get(key).length;keys++){
          // console.log(this.TempData.campaignId)
          if(this.Hourmap.get(key)[keys].campaignId===this.TempData[0].campaignId){

            this.HourList.push(this.Hourmap.get(key)[keys])
          }
        }
      }
      let str=[{
        nameid:'',
        balance:'',
        chengben:''
      }];
      str[0].nameid=this.TempData[0].nameid;
      str[0].balance=this.TempData[0].balance;
      for(let i in this.HourList){
        console.log(this.HourList[i].spent)
        console.log(this.HourList[i].formsubmitCount)
        if (this.HourList[i].formsubmitCount===0){
          str[0].chengben=this.HourList[i].spent
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }else {
          str[0].chengben=this.HourList[i].spent/this.HourList[i].formsubmitCount
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }


        this.HourList[i]=this.hb(this.HourList[i],str[0])
      }
      this.table=true



      // get发送请求获取本条的投放时间
      // 生成折线图


    },

    //切换开关
    changeSwitch(value,row,index){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      const { id,pauseState,userId} = row
      let params = {
        userId:userId,
        id:id,
        pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
      };

      this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+this.sks+'&timestamp='+
        time1+'&nonce='+nonce+'&advertiser_id='+params.userId,{
        ids:params.id,
        startAndStop:params.pauseState
      }).then(async res=> {
        if (res.data.code === 0) {
          this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
        }
      })

    },

    //限额显示的规则
    rule1(row,column){
      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },
    //总汇规则
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }

          if (index === 16) {

            return;

          }
          if (index === 17) {

            return;

          }

          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="CAMPAIGN"){ //计划层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }
          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(2);
            sums[index]=sums[index]/10
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }     if (index === 12) {

            return;

          }
          if (index === 14) {
            sums[index] = sums[index-5]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 16) {
            sums[index] = sums[index-7]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 18) {
            sums[index] = sums[index-9]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 19) {

            return;

          }if (index === 20) {

            return;

          }

          if (index === 21) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }
    },

    //导出表单api
    exportExcel () {
      /* generate workbook object from table */
      var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)

      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    },

    //规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },
    rule2(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]/100000).toFixed(2)
        return percent
      }
    },
    //查询时间选择器函数
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },

    //渲染data、数据处理通用方法
    windowList(){
      //渲染页
      this.temp=JSON.parse(JSON.stringify(this.datadata))
      this.temp1=JSON.parse(JSON.stringify(this.namedata))
      this.temp3=JSON.parse(JSON.stringify(this.playCode))
      for (let key = 0; key < this.temp.length; key++) {
        this.ctrJson[0].flag=false;
        let t=0;
        this.ctrJson[0].nameid=this.temp1[key].name
        this.temp1[key].balance = this.temp1[key].balance / 100000
        this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
        if (this.temp2[key].spent===0){
          this.ctrJson[0].but=0
        }else if (this.temp2[key].formsubmitCount===0){
          this.ctrJson[0].but=this.temp2[key].spent
        }else {
          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
        }

        this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
        this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
        let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
        this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);



        this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
        this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
        let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
        this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
        this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
        this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
        let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
        this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdycl=0
        }else if (this.temp2[key].customRetainCount===0){
          this.ctrJson[0].zdycl=this.temp2[key].spent
        }else {

          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
        }




        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdyff=0
        }else if (this.temp2[key].customPayCount===0){
          this.ctrJson[0].zdyff=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
        }


        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdylh=0
        }else if (this.temp2[key].reactivation===0){
          this.ctrJson[0].zdylh=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);
        }




        //  限额提醒代码
        if(this.temp3[key].dailyBudget!=-1){
          t=this.temp3[key].dailyBudget/100000
          t=t*0.8
          if (this.temp2[key].spent>=t){
            this.ctrJson[0].flag=true;
          }
        }
        this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
        this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])
      }
      this.temp2=JSON.parse(JSON.stringify(this.temp2))
      this.datas=this.temp2
      console.log(this.temp2)
      this.isDisable = false
      if (this.value==="DAY"){
        this.flag=false;
        if (this.values==="GROUP"){
          this.dingshi=true;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=true;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }else if (this.value==="HOUR"){
        this.flag=true;
        if (this.values==="GROUP"){
          this.dingshi=false;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=false;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }

      this.loading=false
    },


    //查询广告效果api
    async PostListQuery(parms){

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {

        console.log(resp.data.code)
        if (resp.data.code!==60806)
        {
          if (resp.data.data.items !=null){
            if (this.value==="HOUR"){
              // 存取小时的数据[]
              this.sums=this.sums+1;
              console.log(resp.data.data.items)
              this.Hourmap.set(this.sums,resp.data.data.items)

              // console.log(this.Hourmap.get(parms.a))
              let arr=[];
              let map=new Map;
              for(let key in resp.data.data.items){
                var time=new Date(resp.data.data.items[key].reportTime)
                let reTimeHour=time.getHours(); //获取返回整点时间
                var date=new Date()
                let hour=date.getHours();  // 获取当前时间
                if (hour===reTimeHour){
                  arr.push(key)   //定位现在整时位置
                  map.set(key,resp.data.data.items[key])// 记录下现在的数据
                }
              }
              for (let keys in arr){

                this.datadata.push(map.get(arr[keys]))
                let obj={
                  ids:resp.data.data.items[arr[keys]].campaignId,
                  lengths:arr.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:arr.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);

            }else{
              console.log(resp.data.data.items)
              for (let b=0;b<resp.data.data.items.length;b++){
                this.datadata.push(resp.data.data.items[b])
                let obj={
                  ids:resp.data.data.items[b].campaignId,
                  lengths:resp.data.data.items.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:resp.data.data.items.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);
            }

          }
        }

      })

    },

    //修改限额api
    async PostGroup(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success'
          });
        }

      })


    },

    //修改投放日期api
    async PostMoeny(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,

        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });
          this.getDataList()
        }

      })


    },
    //查询账号信息api
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {
            }
          }

        )
    },
    // 查询计划状态api
    async PostListplayCode(pams){
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          console.log(resps.data.data.list[0])
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },

    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },


    getDataList() {
      this.loading=true
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]
      if(this.userUalue[0]==="tangtang"){
        this.isDisable = true
        this.TimeChange();
      }
    },


    async TimeChange () {
      if (this.userUalue[1]==="fjwc"){
        for (let a = 0; a < this.fjwc.length; a++) {

            console.log(this.sks)
            let parms={
              a:a,
              startDate:this.value2.at(0),
              endDate: this.value2.at(1),
              summaryType: this.value,
              level: this.values,
              token:this.tangtang[0],
              adid:this.fjwc
            }
            await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="sqyj"){
        for (let a = 0; a < this.sqyj.length; a++) {

          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.tangtang[0],
            adid:this.sqyj
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="lhsq"){
        for (let a = 0; a < this.lhsq.length; a++) {
          this.sks=this.lhsqtoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.lhsq
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()
      }
      else  if (this.userUalue[1]==="fzy"){
        for (let a = 0; a < this.fzy.length; a++) {
          this.sks=this.fzytoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.fzy
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="tabj"){
        for (let a = 0; a < this.tabj.length; a++) {
          this.sks=this.tabjtoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.tabj
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="zabx"){
        for (let a = 0; a < this.zabx.length; a++) {
          this.sks=this.zabxtoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zabx
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="thys"){
        for (let a = 0; a < this.thys.length; a++) {
          this.sks=this.thystoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.thys
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="gonjj"){
        for (let a = 0; a < this.gonjj.length; a++) {
          this.sks=this.gonjjtoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.gonjj
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }       else  if (this.userUalue[1]==="tianc"){
        for (let a = 0; a < this.tianc.length; a++) {
          this.sks=this.tianctoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.tianc
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }else  if (this.userUalue[1]==="wzjiu"){
        for (let a = 0; a < this.wzjiu.length; a++) {
          this.sks=this.wzjiutoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.wzjiu
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      } else  if (this.userUalue[1]==="qhjiu"){
        for (let a = 0; a < this.qhjiu.length; a++) {
          this.sks=this.qhjiutoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.qhjiu
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      } else  if (this.userUalue[1]==="ftjiu"){
        for (let a = 0; a < this.ftjiu.length; a++) {
          this.sks=this.ftjiutoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ftjiu
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      } else  if (this.userUalue[1]==="yangnai"){
        for (let a = 0; a < this.yangnai.length; a++) {
          this.sks=this.yangnaitoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.yangnai
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="fnbj"){
        for (let a = 0; a < this.fnbj.length; a++) {
          this.sks=this.fnbjtoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.fnbj
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="tgxys"){
        for (let a = 0; a < this.tgxys.length; a++) {
          this.sks=this.tgxystoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.tgxys
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="qdsq"){
        for (let a = 0; a < this.qdsq.length; a++) {
          this.sks=this.qdsqtoken[0]
          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.qdsq
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="aicp"){
        for (let a = 0; a < this.aicp.length; a++) {

          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.aicptoken[0],
            adid:this.aicp
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="lltb"){
        for (let a = 0; a < this.lltb.length; a++) {

          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.lltbtoken[0],
            adid:this.lltb
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="ltsq"){
        for (let a = 0; a < this.ltsq.length; a++) {

          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.ltsqtoken[0],
            adid:this.ltsq
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }

      else  if (this.userUalue[1]==="lttm"){
        for (let a = 0; a < this.lttm.length; a++) {

          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.lttmtoken[0],
            adid:this.lttm
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="llks"){
        for (let a = 0; a < this.llks.length; a++) {

          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.llkstoken[0],
            adid:this.llks
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else  if (this.userUalue[1]==="zgbzf"){
        for (let a = 0; a < this.zgbzf.length; a++) {

          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.zgbzftoken[0],
            adid:this.zgbzf
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }

      else  if (this.userUalue[1]==="jmhd"){
        for (let a = 0; a < this.jmhd.length; a++) {

          console.log(this.sks)
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.jmhdtoken[0],
            adid:this.jmhd
          }
          await this.PostListQuery(parms)

        }
        //渲染页面
        this.windowList()

      }
      else if(this.userUalue[1]==="ttgx"){
        this.sks=this.ttgxtoken[0]
        this.sums=0;
        for (let a = 0; a < this.ttgx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ttgx
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="qwyy"){
        this.sks=this.qwyytoken[0]
        this.sums=0;
        for (let a = 0; a < this.qwyy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.qwyy
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="hy"){
        this.sks=this.tangtang[1],
        this.sums=0;
        for (let a = 0; a < this.hy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.hy
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="zgyy"){
        this.sks=this.zgyytoken[0],
          this.sums=0;
        for (let a = 0; a < this.zgyy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zgyy
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="yjj"){
        this.sks=this.tangtang[1],
          this.sums=0;
        for (let a = 0; a < this.yjj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.yjj
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="zcrmc"){
        this.sks=this.zcrmctoken[0],
          this.sums=0;
        for (let a = 0; a < this.zcrmc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zcrmc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="xhsh"){
        this.sks=this.xhshtoken[0],
          this.sums=0;
        for (let a = 0; a < this.xhsh.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.xhsh
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="jzhd"){
        this.sks=this.jzhdtoken[0],
          this.sums=0;
        for (let a = 0; a < this.jzhd.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.jzhd
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="jhcs"){
        this.sks=this.jhcstoken[0]
        this.sums=0;
        for (let a = 0; a < this.jhcs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.jhcs
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()



      }
      else if(this.userUalue[1]==="zjwc"){
        this.sks=this.tangtang[0]
        this.sums=0;
        for (let a = 0; a < this.zjwc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zjwc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      else if(this.userUalue[1]==="yx"){
        this.sks=this.tangtang[3]
        this.sums=0;
        for (let a = 0; a < this.yx.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.yx
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

      }
      else if(this.userUalue[1]==="hqyt"){

        this.sks=this.tangtang[4]
        this.sums=0;
        for (let a = 0; a < this.hqyt.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.hqyt
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }   else if(this.userUalue[1]==="azmc"){

        this.sks=this.azmctoken[0]
        this.sums=0;
        for (let a = 0; a < this.azmc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.azmc
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }

      else if(this.userUalue[1]==="azxys"){

        this.sks=this.azxystoken[0]
        this.sums=0;
        for (let a = 0; a < this.azxys.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.azxys
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      else if(this.userUalue[1]==="qqsh"){

        this.sks=this.qqshtoken[0]
        this.sums=0;
        for (let a = 0; a < this.qqsh.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.qqsh
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }
      //渲染页面

      else if(this.userUalue[1]==="zer"){

        this.sks=this.tangtang[4]
        this.sums=0;
        for (let a = 0; a < this.zer.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zer
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()
      }

      else if(this.userUalue[1]==="jz"){

        this.sks=this.jztoken[0]
        this.sums=0;
        for (let a = 0; a < this.jz.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.jz
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

        //渲染页面


      }
      else if(this.userUalue[1]==="bxm"){

        this.sks=this.bxmtoken[0]
        this.sums=0;
        for (let a = 0; a < this.bxm.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.bxm
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()

        //渲染页面


      }
      if (this.userUalue[1]==="ljs"){
        this.sks=this.ljstoken[0]
        this.sums=0;
        for (let a = 0; a < this.ljs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.ljs
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
      if (this.userUalue[1]==="bbkj"){
        this.sks=this.bbkjtoken[0]
        this.sums=0;
        for (let a = 0; a < this.bbkj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.bbkj
          }
          await this.PostListQuery(parms)
        }
        //渲染页面
        this.windowList()


      }
    },

  },
  created () {  },
}
</script>




// WEBPACK FOOTER //
// src/components/geleio.vue